var fn = function( obj ){
var __t,__p='';
__p+='#pragma SLOT version\n\n#pragma SLOT definitions\n\n#pragma SLOT precision\n\n'+
( require( "nanogl-pbr/glsl/includes/glsl-compat.frag" )() )+
'\n#pragma SLOT pf\n\nIN vec3 vTexCoord;\n\nuniform sampler2D tGradient;\n\nvoid main(void){\n\n  #if HAS_progress\n  float inf = step(progress(), 0.5);\n  float high = step(0.5, vTexCoord.z);\n  float low = 1.0 - high;\n  float right = step(vTexCoord.z - progress(), 0.0);\n  float a = mix(high * right, low * (1.0 - right), inf);\n  #else\n  float a = 1.0;\n  #endif\n  vec4 color = texture2D(tGradient, vTexCoord.xy);\n  \n  FragColor = vec4(color.rgb, a);\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;